export default __webpack_public_path__ + "078da817745d27e9b201ffb433f56519.svg";